import React, { Component } from 'react'

import { SearchRectangular } from './slyled'

export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value || props.defaultValue || ''
    }
  }

  handleChange = (e) => {
    const value = e.target.value
    this.setState({ value })
    if (this.props.onChange) {
      this.props.onChange(e)
    }
  }

  render () {
    const props = this.props
    const { value } = this.state

    return (
      <SearchRectangular 
        {...props} 
        value={value}
        onChange={this.handleChange}
        allowClear
        className={value ? 'search-with-value' : ''}
      />
    )
  }
}
